import type { FollowInvite } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCreateFollowInvite as useCreateFollowInviteAPI } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import { useFollowInvites } from "./useFollowInvites"
import { noticeError } from "src/utils"

export function useCreateFollowInvite() {
  const createFollowInvite = useCreateFollowInviteAPI()
  const {
    mutate,
    data: followInvites,
  } = useFollowInvites()

  return useMemo(
    () => createFollowInvite && (async (followInvite: Partial<FollowInvite>) => {
      try {
        const response = await createFollowInvite(followInvite)

        if (followInvites) {
          void mutate([
            response.data.follow_invite,
            ...followInvites,
          ])
        } else {
          void mutate()
        }
      } catch (e) {
        noticeError(
          e,
          "CreateFollowInvite",
          { followInvite },
        )
        throw e
      }
    }),
    [
      createFollowInvite,
      followInvites,
      mutate,
    ],
  )
}
